const getGridImageSizes = (wrapperWidth: number, wrapperHeight: number, image: HTMLImageElement) => {
  const imageWidth = image.naturalWidth || 0;
  const imageHeight = image.naturalHeight || 0;
  const coefficient = Math.min(wrapperWidth / imageWidth, wrapperHeight / imageHeight);

  const newWidth = `${((coefficient * imageWidth) / wrapperWidth) * 100}%`;
  const newHeight = `${((coefficient * imageHeight) / wrapperHeight) * 100}%`;

  return {
    width: newWidth,
    height: newHeight,
  };
};

export default getGridImageSizes;
